import { Card, Col, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import { DEV_SERVER } from "../../../constants/urls";
import { toast } from "react-toastify";
import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { userSignal } from "../../../signal/userSignal";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';


import * as moment from "moment";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import DataTable from "react-data-table-component";
import ProductModal from "./ProductModal";
import AddProductModal from "./AddProductModal";
import { productSignal } from "../../../signal/productSignal";
import * as XLSX from 'xlsx';

export default function ProductList() {

    const [products, setProducts] = useState([]);
    const fileInputRef = useRef(null);
    const [productsToDisplay, setProductsToDisplay] = useState([]);
    const [search, setSearch] = useState("");
    const [productModal, setProductModal] = useState(null);
    const [productEdit, setProductEdit] = useState(null);
    const [productModalShow, setProductModalShow] = useState(false);
    const [addProductModalShow, setAddProductModalShow] = useState(false);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(35);
    const [totalItems, setTotalItems] = useState(0);

    // useEffect(() => {
    //     setProductsToDisplay(products.filter((item) => {
    //         if (search === "") return true;
    //         if (item?.name?.toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.description?.toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.productCode?.toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.price?.toString().toLowerCase().includes(search.toLowerCase())) return true;
    //         if (moment(item.updatedAt).format("DD/MM/YY hh:mm A").toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.category.toString().toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.packagingTypes?.map((item) => item.toLowerCase()).join(" ").includes(search.toLowerCase())) return true;

    //         return false;
    //     }))
    // }, [search, products])

    const getProducts = useQuery("products", async ({ signal }) => {
        let resp = await axios.get(`${DEV_SERVER}/product/v2/dashboard?page=${page}&perPage=${perPage}&search=${search}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
            signal: signal
        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                setProducts(data.data?.products || []);
                setPage(data.data?.page || 1);
                setPerPage(data.data?.perPage || 35);
                setTotalItems(data.data?.totalItems || 0);

            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    });

    const productDeleteMutation = useMutation((body) => axios.delete(`${DEV_SERVER}/product/v2/${body.id}`, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`
        }
    }), {
        onSuccess: (data) => {
            if (data.data.status) {
                toast.success("Product deleted successfully")
                refetchProducts()
            } else {
                toast.error(data.data.message)
            }
        },
        onError: (error) => {
            console.log("error ", error)
            if (error.response?.data?.message) {
                toast.error(error.response.data.message)
            } else {
                toast.error(error.message)
            }
        }
    })

    const handleProductDelete = (id) => {

        confirmAlert({
            title: 'Confirm to delete',
            message: 'Are you sure you want to delete this product?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        productDeleteMutation.mutate({ id: id })
                    }
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ],
            overlayClassName: "overlay-custom-confirm-alert",
        });


    }

    const handleDownloadTemplate = () => {
        // Create template data with headers only
        const template = [
            {
                name: '',
                productCode: '',
                description: '',
                category: '',
                packagingTypes: '',
                Price: ''
            }
        ];

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(template);
        
        // Set column widths
        worksheet['!cols'] = [
            { wch: 15 },  // name
            { wch: 15 },  // productCode
            { wch: 30 },  // description
            { wch: 15 },  // category
            { wch: 20 },  // packagingTypes
            { wch: 10 }   // Price
        ];

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Products');

        // Download file
        XLSX.writeFile(workbook, 'Product_Template.xlsx');
        toast.success('Template downloaded successfully');
    };

    const handleImportExcel = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = async (e) => {
            try {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(worksheet);

                if (jsonData.length === 0) {
                    toast.error('Excel file is empty');
                    return;
                }

                // Filter out empty rows and transform data
                const products = jsonData.filter(row => row.name || row.productCode).map(row => ({
                    name: row.name || '',
                    productCode: row.productCode || '',
                    description: row.description || '',
                    category: row.category || '',
                    packagingTypes: row.packagingTypes ? row.packagingTypes.split(',').map(p => p.trim()).filter(p => p) : [],
                    price: parseFloat(row.Price) || 0
                }));

                if (products.length === 0) {
                    toast.error('No valid products found in Excel file');
                    return;
                }

                toast.info(`Importing ${products.length} products...`);

                // Import products one by one
                let successCount = 0;
                let failCount = 0;

                for (const product of products) {
                    try {
                        const response = await axios.post(`${DEV_SERVER}/product/v2`, product, {
                            headers: {
                                Authorization: `Bearer ${userSignal.value?.token}`
                            }
                        });
                        
                        if (response.data.status) {
                            successCount++;
                        } else {
                            failCount++;
                            console.error('Failed to import product:', product.name, response.data.message);
                        }
                    } catch (error) {
                        failCount++;
                        console.error('Error importing product:', product.name, error);
                    }
                }

                // Show results
                if (successCount > 0) {
                    toast.success(`Successfully imported ${successCount} product(s)`);
                    refetchProducts();
                }
                if (failCount > 0) {
                    toast.warning(`Failed to import ${failCount} product(s)`);
                }

            } catch (error) {
                toast.error('Failed to read Excel file');
                console.error(error);
            }
        };
        reader.readAsArrayBuffer(file);
        
        // Reset input
        event.target.value = '';
    };


    const refetchProducts = () => {
        getProducts.refetch({ cancelRefetch: true });
    }

    useEffect(() => {
        refetchProducts();
    }, [page, perPage, search])

    const columns = [
        {
            name: "Name",
            color: true,
            selector: (row) => {
                return <div className="d-flex align-items-center" style={{ columnGap: "0.4rem" }}>
                    <Zoom><img src={row?.images?.length > 0 && row?.images[0]?.url} onLoad={(e) => { e.target.style.pointerEvents = "unset" }} onError={(e) => { e.target.style.pointerEvents = "none" }} style={{ pointerEvents: "none", width: "30px", height: "30px", borderRadius: "10px" }} /></Zoom>
                    <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.name}</Tooltip>}>
                        <span>{row?.name}</span>
                    </OverlayTrigger>
                </div>
            },
        },
        {
            name: "Product Code",
            color: true,
            center: true,
            selector: "productCode",
        },
        {
            name: "Category",
            center: true,
            selector: "category",
            cell: (row) => {
                return <span>{row?.category}</span>
            }
        },
        {
            name: "Packaging Types",
            center: true,
            selector: (row) => {
                return row?.packagingTypes?.join(", ")
            }
        },
        {
            name: "Price",
            center: true,
            selector: "price",
            cell: (row) => {
                return <span>₹ {row?.price}</span>
            },
            sortable: true,
        },
        {
            name: "Updated At",
            color: true,
            center: true,
            selector: (row) => {
                return moment(row?.updatedAt).format("DD/MM/YY hh:mm A")
            }
        },
        {
            name: "Action",
            color: true,
            center: true,
            selector: (row) => {
                return <div style={{ display: "flex", columnGap: "0.5rem", flexWrap: "wrap" }}>
                    {userSignal.value?.user?.isAdmin &&
                        <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Edit</Tooltip>}>
                            <span style={{ cursor: "pointer" }} onClick={() => {
                                setProductModal(row);
                                setProductEdit(true);
                                setProductModalShow(true);
                            }}><i className="far fa-edit table-icons"></i></span>
                        </OverlayTrigger>
                    }
                    {userSignal.value?.user?.isAdmin &&
                        <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Delete</Tooltip>}>
                            <span style={{ cursor: "pointer" }} onClick={() => {
                                handleProductDelete(row?.id)
                            }}><i className="far fa-trash-alt table-icons"></i></span>
                        </OverlayTrigger>
                    }
                    <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>View</Tooltip>}>
                        <span style={{ cursor: "pointer" }} onClick={() => {
                            setProductModal(row);
                            setProductEdit(false);
                            setProductModalShow(true);
                        }}><i className="far fa-eye table-icons"></i></span>
                    </OverlayTrigger>
                </div>
            }
        }
    ]

    return (
        <>
            <div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">Product List</h4>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", columnGap: "1rem", marginBottom: "1rem" }}>
                                    <div>
                                        <label htmlFor="search">Search</label>
                                        <input type="search" id="search" className="form-control vanila-datepicker" names="start" placeholder="Search anything..." value={search} onChange={(e) => setSearch(e.target.value)} />
                                    </div>
                                    <div style={{ display: "flex", columnGap: "0.5rem" }}>
                                        <button className="btn btn-outline-primary" onClick={handleDownloadTemplate}>
                                            <i className="fas fa-download"></i>
                                            <span className="ms-1">Download Template</span>
                                        </button>
                                        <button className="btn btn-outline-success" onClick={() => fileInputRef.current?.click()}>
                                            <i className="fas fa-file-excel"></i>
                                            <span className="ms-1">Import Excel</span>
                                        </button>
                                        <input 
                                            type="file" 
                                            ref={fileInputRef}
                                            style={{ display: 'none' }}
                                            accept=".xlsx, .xls"
                                            onChange={handleImportExcel}
                                        />
                                        <button className="btn btn-primary" onClick={() => setAddProductModalShow(true)}>
                                            <i className="fas fa-plus"></i>
                                            <span className="ms-1">Add Product</span>
                                        </button>
                                    </div>
                                </div>
                                {(!getProducts.isLoading && !getProducts?.isFetching) &&

                                    <DataTable
                                        customStyles={{ cells: "center" }}
                                        columns={columns}
                                        data={products}
                                        pagination={true}
                                        paginationServer={true}
                                        paginationTotalRows={totalItems}
                                        paginationPerPage={perPage}
                                        paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 35]}
                                        paginationDefaultPage={page}
                                        onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                                            setPerPage(currentRowsPerPage);
                                        }}
                                        onChangePage={(currentPage) => {
                                            setPage(currentPage);
                                        }}
                                    />}
                                {getProducts.isLoading || getProducts?.isFetching && <div className="d-flex justify-content-center">
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                                }
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>

            <ProductModal show={productModalShow} edit={productEdit} refetchProducts={refetchProducts} product={productModal} close={() => {
                setProductModal(null);
                setProductEdit(false);
                setProductModalShow(false);
            }} />

            {addProductModalShow && <AddProductModal show={addProductModalShow} refetchProducts={refetchProducts} close={() => {
                setAddProductModalShow(false);
            }} />}
        </>
    )
}